module.exports = __webpack_public_path__ + "static/img/SRGLogo_greyscale_2022.88d737a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SRGLogo_greyscale_2022.svg
// module id = dJ44
// module chunks = 0